import {
  type DataProvider,
  type RaRecord,
  type ResourceCallbacks,
  withLifecycleCallbacks,
} from 'ra-core';
import { type AdminDataProvider } from './adminDataProvider';
import { fileUploadHooks } from './transformHooks/fileUpload';
import { postCreateDataTranformHook } from './transformHooks/postCreationDataTransform';
import { badgesDataTransform } from './transformHooks/badgesDataTransform';
import { checklistsDataTransform } from './transformHooks/checklistDataTransform';

// Adds support for custom `DataProvider` types by remapping `DataProvider` to `AdminDataProvider`
export type LifecycleHooks<T extends RaRecord = any> = {
  [K in keyof ResourceCallbacks<T>]: ResourceCallbacks<T>[K] extends
    | ((params: infer TRecord, dataProvider: DataProvider) => infer TResult)
    | undefined
    ?
        | ((params: TRecord, dataProvider: AdminDataProvider) => TResult)
        | undefined
    : ResourceCallbacks<T>[K];
};

export const addProviderLifecycleHooks = <T extends AdminDataProvider>(
  provider: T
): T =>
  withLifecycleCallbacks(provider, [
    ...fileUploadHooks,
    ...postCreateDataTranformHook,
    ...badgesDataTransform,
    ...checklistsDataTransform,
  ]);
